import React from "react"
import styled from "styled-components"

import { compose } from "recompose"
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps"

const apiKey = process.env.GATSBY_GOOGLE_MAP_API_KEY

const MapWithAMarker = compose(
  withScriptjs,
  withGoogleMap
)(props => {
  return (
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat: 48.13578, lng: 11.57216 }}
    >
      <Marker position={{ lat: 48.13578, lng: 11.57216 }}>
        <InfoWindow>
          <div style={{ textAlign: "center" }}>
            <p style={{ fontWeight: "bold" }}>
              WTW Weidinger · Thiele · Wenninger
            </p>
            <p> Sendlinger Str. 7</p>
            <p>80331 München</p>
          </div>
        </InfoWindow>
      </Marker>
    </GoogleMap>
  )
})

const Map = () => {
  return (
    <MapWrapper id="map">
      <MapWithAMarker
        className="map"
        // selectedMarker={selectedMarker}
        // markers={locations}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${apiKey}`}
      //  googleMapURL={`https://maps.googleapis.com/maps/api/staticmap?center=40.714728,-73.998672&zoom=12&size=400x400&maptype=terrain&key=${apiKey}
      //  `}
        // onClick={handleClick}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div className="map" />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </MapWrapper>
  )
}

export default Map
const MapWrapper = styled.div`
  .map {
    height: 100vh;
  }
`
